import { FlagsControllerApi } from "../../../services";
import { ArchiveMutation } from "../../../hooks/useArchiveState";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author [Atish Bagate]
 */
export const useFlagArchive = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new FlagsControllerApi(getConfigObject()).updatePatientFlagArchiveStatus1(
      param.id,
      param.status,
      param.xTENANTID //xTENANTID
    )
  );
